const charCodeForA = 97;
const charCodeForZ = 122;

export const translateBandIntoNumeric = (bandTitle) => {
	try {
		const band = bandTitle.split(' ')[1];

		if (band.length === 1) { return Number.parseInt(band, 10); }

		return Number.parseFloat(band
			.split('').map((bandSymbol) => {
				if (parseInt(bandSymbol, 10)) { return bandSymbol; }
				const symbolCharCode = bandSymbol.charCodeAt();

				if (symbolCharCode < charCodeForA && symbolCharCode > charCodeForZ) {
					throw Error('Char code is out of range');
				}

				return `.${symbolCharCode - charCodeForA + 1}`;
			}).join(''));
	} catch (error) {
		return bandTitle;
	}
};

export const translateNumericIntoBand = (numeric) => {
	const [num, fraction] = `${numeric}`.split('.');

	if ((!Number.isNaN(numeric) || Number.isInteger(+numeric))
		&& !Number.isNaN(numeric) && numeric % 1 === 0) {
		return numeric;
	}

	return `${num}${String.fromCharCode(charCodeForA + +fraction - 1)}`;
};
